var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCardImg = function SvgCardImg(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 252,
    height: 231,
    viewBox: "0 0 252 231",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 240021"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    opacity: 0.3,
    d: "M34.1347 92.3558H184.854C198.985 92.3558 210.483 103.418 210.483 117.647V175.398C215.218 173.986 219.212 170.312 220.851 165.215L241.403 101.323L50.806 40.0139L34.1347 92.3558Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    opacity: 0.3,
    d: "M240.928 52.6347L79.5777 0.734319C71.5013 -1.86386 62.8238 2.65176 60.1964 10.8205L58.666 15.579L249.264 76.8875L250.794 72.129C253.422 63.9602 249.004 55.2329 240.928 52.6347Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M184.854 102.11H15.3616C6.87765 102.11 0 109.066 0 117.647V215.43C0 224.011 6.87765 230.966 15.3616 230.966H184.854C193.338 230.966 200.215 224.011 200.215 215.43V117.647C200.215 109.066 193.338 102.11 184.854 102.11ZM123.209 205.298H20.5349V189.897H123.209V205.298ZM174.547 153.96C174.547 156.795 172.248 159.094 169.413 159.094H143.744C140.909 159.094 138.611 156.795 138.611 153.96V128.292C138.611 125.457 140.909 123.158 143.744 123.158H169.413C172.248 123.158 174.547 125.457 174.547 128.292V153.96Z",
    fill: "#AFBDE8"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCardImg, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/CardImg.480fa103.svg";
export { ForwardRef as ReactComponent };